<div class="modal-body _pop-overlay">
  <div class="mid-panel">
    <div class="_pop-mid-content _math-key-popup" appModalFocusOnInit="100" tabindex="-1">
      <!--start check box popup-->
      <div class="_math-key-mid">
        <div class="_top-icon">
          <img src="assets/images/contact-email.svg" aria-hidden="true" />
        </div>
        <div class="heading">
          {{ 'emailPdfpopupHeading' | translate }}
        </div>
        <div class="_form-section _enterform">
          <form [formGroup]="formValues" (ngSubmit)="sendPdf()">
            <!--form feild end-->
            <!--form feild start-->
            <div class="form-field">
              <div class="_field _full _icons _email-icon" style="text-align: left !important">
                <label>
                  {{ 'emailPdfEmail' | translate }}
                </label>
                <input type="text" formControlName="email" autocomplete="off" maxlength="75" appDynamicTabIndex tabindex="0" />
                <label class="error-msg" *ngIf="f.email.errors?.required && (f.email.touched || f.email.dirty)">
                  {{ 'emailRequired' | translate }}
                </label>

                <label for="" *ngIf="f.email.errors?.email && (f.email.touched || f.email.dirty)" class="error-msg">
                  {{ 'emailInvalid' | translate }}
                </label>
                <label
                  for=""
                  class="error-msg"
                  *ngIf="f.email.errors?.invalidEmail && !f.email.errors?.email && !f.email.errors?.required && (f.email.touched || f.email.dirty)"
                >
                  {{ 'emailInvalid' | translate }}
                </label>
              </div>
            </div>
            <div class="form-field">
              <div class="_field _full" style="text-align: left !important">
                <label>
                  {{ 'emailPdfSubject' | translate }}
                </label>
                <input
                  type="text"
                  formControlName="subject"
                  autocomplete="off"
                  maxlength="81"
                  style="padding-left: 10px !important"
                  appDynamicTabIndex
                  tabindex="0"
                />
                <label class="error-msg" *ngIf="f.subject.errors?.required && (f.subject.touched || f.subject.dirty)">
                  {{ 'subjectRequired' | translate }}
                </label>
                <label *ngIf="f.subject.errors?.containOnlySpace" class="error-msg">
                  {{ 'subjectNotContainOnlySpace' | translate }}
                </label>
                <label
                  class="error-msg"
                  *ngIf="!f.subject.errors?.containOnlySpace && f.subject.errors?.maxlength && (f.subject.touched || f.subject.dirty)"
                >
                  {{ 'subjectMax' | translate: { value: f.subject.errors?.maxlength.requiredLength } }}
                </label>
                <label class="error-msg" *ngIf="!f.subject.errors?.maxlength && (f.subject.dirty || f.subject.touched) && f.subject.errors?.pattern">
                  {{ 'messagePatternInvalid' | translate }}
                </label>
              </div>
            </div>
            <div class="form-field">
              <label>
                {{ 'emailPdfMessage' | translate }}
              </label>
              <textarea
                class="scrollBar"
                style="min-height: 70px !important"
                formControlName="message"
                autocomplete="off"
                maxlength="501"
                appDynamicTabIndex
                tabindex="0"
              ></textarea>
              <label class="error-msg" *ngIf="f.message.errors?.required && (f.message.touched || f.message.dirty)">
                {{ 'messageRequired' | translate }}
              </label>
              <label *ngIf="f.message.errors?.containOnlySpace" class="error-msg">
                {{ 'messageNotContainOnlySpace' | translate }}
              </label>
              <label
                class="error-msg"
                *ngIf="!f.message.errors?.containOnlySpace && f.message.errors?.maxlength && (f.message.touched || f.message.dirty)"
              >
                {{ 'contactMessageMax' | translate: { value: f.message.errors?.maxlength.requiredLength } }}
              </label>
              <label
                class="error-msg"
                *ngIf="
                  !f.message.errors?.maxlength &&
                  !f.message.errors?.containOnlySpace &&
                  (f.message.dirty || f.message.touched) &&
                  f.message.errors?.pattern
                "
              >
                {{ 'emailMessagePatternInvalid' | translate }}
              </label>
            </div>
            <!--form feild end-->
            <div class="_popup-btn mt-5">
              <button type="button" class="button _cancel-btn" (click)="closeModal()" appDynamicTabIndex tabindex="0">
                <div class="d-flex align-items-center">
                  <span class="mr-3">{{ 'cancel' | translate }}</span>
                  <img class="ml-auto next-arrow mb-n1" src="assets/images/next-arrow.svg" aria-hidden="true" width="13" height="15" />
                </div>
              </button>
              <button type="submit" class="button secondary" appDynamicTabIndex tabindex="0">
                <div class="d-flex align-items-center">
                  <span class="mr-3">{{ 'sendEmail' | translate }}</span>
                  <img class="ml-auto next-arrow mb-n1" src="assets/images/next-arrow.svg" aria-hidden="true" width="13" height="15" />
                </div>
              </button>
            </div>
            <!--form feild end-->
          </form>
        </div>
      </div>

      <!--end check box popup-->
    </div>
  </div>
</div>
